// Client-side mirror of /api/countries. Kept in sync manually — for anything
// mission-critical (currency, gateways, tax) always fetch from /api/countries.
// This constant is used only for immediate SSR-safe render of dropdowns.

export const AFRICAN_COUNTRIES = [
  { iso: "ZW", name: "Zimbabwe",      currency: "USD" },
  { iso: "ZA", name: "South Africa",  currency: "ZAR" },
  { iso: "BW", name: "Botswana",      currency: "BWP" },
  { iso: "ZM", name: "Zambia",        currency: "ZMW" },
  { iso: "NA", name: "Namibia",       currency: "NAD" },
  { iso: "MZ", name: "Mozambique",    currency: "MZN" },
  { iso: "KE", name: "Kenya",         currency: "KES" },
  { iso: "TZ", name: "Tanzania",      currency: "TZS" },
  { iso: "UG", name: "Uganda",        currency: "UGX" },
  { iso: "RW", name: "Rwanda",        currency: "RWF" },
  { iso: "NG", name: "Nigeria",       currency: "NGN" },
  { iso: "GH", name: "Ghana",         currency: "GHS" },
  { iso: "EG", name: "Egypt",         currency: "EGP" },
  { iso: "MA", name: "Morocco",       currency: "MAD" },
];

// Cities used to prime dropdowns when the user hasn't selected a country yet.
// This is intentionally short — full lists come from /api/countries/{iso}.
export const AFRICAN_CITIES_FALLBACK = [
  // Southern
  "Johannesburg", "Cape Town", "Pretoria", "Durban",
  "Harare", "Bulawayo", "Mutare",
  "Gaborone", "Windhoek", "Lusaka", "Maputo",
  // East
  "Nairobi", "Mombasa", "Dar es Salaam", "Kampala", "Kigali",
  // West
  "Lagos", "Abuja", "Accra", "Kumasi",
  // North
  "Cairo", "Alexandria", "Casablanca", "Rabat",
];

export const countryByIso = (iso) =>
  AFRICAN_COUNTRIES.find((c) => c.iso === (iso || "").toUpperCase());
